import Prismic from "prismic-javascript";

const apiEndpoint = "https://u-pirata.cdn.prismic.io/api/v2";
const accessToken =
  "MC5YczBtUlJFQUFDWUFIWnNj.77-977-977-9Eu-_vTLvv73vv73vv73vv73vv70DPizvv73vv71677-977-9D--_ve-_ve-_vTrvv73vv73vv71Z77-977-977-9bA"; // This is where you would add your access token for a Private repository

export const PrismicClient = Prismic.client(apiEndpoint, { accessToken });
